import styled from "styled-components";

import { DefaultCell } from "./DefaultCell";

/**
 * @deprecated Use TextCell from @similarweb/pro-logic-components instead
 * @see {@link https://gitlab.int.similarweb.io/pro-frontend/pro-logic-components/-/blob/master/src/table/cells/components/core/TextCell/TextCell.tsx}
 */
export const UniqueUsersCell = styled(DefaultCell)`
    padding-right: 12px;
    text-align: right;
`;
